import BaseApi from './base'

class Company extends BaseApi {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.fleetURL}/backoffice`
  }

  getCompanies = (query) => this.client.get(`admin/companies?${query}`)

  getCompanyDetail = (id) => this.client.get(`admin/companies/${id}`)

  addCompany = (data) => this.client.post('admin/companies', data)

  updateCompany = (id, data) => this.client.patch(`admin/companies/${id}`, data)

  deleteCompany = (id) => this.client.delete(`admin/companies/${id}`)

  updateSheetAdditional = (id, data) =>
    this.client.post(`admin/companies/${id}/sheet-additional`, data)

  getSheetAdditional = (id) =>
    this.client.get(`admin/companies/${id}/sheet-additional`)

  getCompanyMembers = (id, query) =>
    this.client.get(`admin/company/${id}/users?${query}`, {
      baseURL: this.baseURL
    })

  getCompanyPilots = (id, query) =>
    this.client.get(`company-pilots?companyTeamId=${id}&${query}`)

  convertToMotherCompany = (id) =>
    this.client.post(`admin/companies/${id}/mother-company`)

  getChildrenCompanies = (id, query) =>
    this.client.get(`admin/companies/${id}/child-company?${query}`)

  addChildrenCompany = (id, data) =>
    this.client.post(`admin/companies/${id}/child-company`, data)

  deleteChildrenCompany = (id) =>
    this.client.delete(`admin/companies/child-company/${id}`)

  getCompanyVehicles = (id, query) =>
    this.client.get(`admin/companies/${id}/sheet-vehicle?${query}`)

  getCompanySubscription = (id, query) =>
    this.client.get(`admin/subscriptions/subscriber/${id}?${query}`)

  getSystemCompanies = (query) => this.client.get(`systems/companies?${query}`)

  getProducedVehicles = ({ companyId, params }) =>
    this.client.get(`company/${companyId}/vehicle/links`, {
      params,
      baseURL: this.baseURL
    })

  addProducedVehicle = ({ companyId, payload }) =>
    this.client.post(`company/${companyId}/vehicle/links`, payload, {
      baseURL: this.baseURL
    })

  deleteProducedVehicle = ({ companyId, linkId }) =>
    this.client.delete(`company/${companyId}/vehicle/links/${linkId}`, {
      baseURL: this.baseURL
    })

  getListLinkableVehicleLinks = ({ companyId, params }) =>
    this.client.get(`company/${companyId}/vehicle/linkable`, {
      params,
      baseURL: this.baseURL
    })
}

export default new Company()
